import { round } from 'lodash';

/**
 *
 * @param {Number} mins
 * @param {Number} allowedRemainder
 * @returns {Number}
 */
function convertMinsToHours(mins, allowedRemainder = 0) {
  // get the extra mins
  const excessMins = mins % 60;

  const allowedNightDiff =
    allowedRemainder === 0 ? mins : mins - (excessMins % allowedRemainder);

  return round(allowedNightDiff / 60, 4);
}

export default convertMinsToHours;
